export const posthogProjectToken =
  process.env.NEXT_PUBLIC_POSTHOG_TOKEN ??
  process.env.NEXT_PUBLIC_POSTHOG_KEY ??
  undefined;

export const posthogManagedProxyHost =
  process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://z.repackify.com";
export const posthogIngestionHost =
  process.env.POSTHOG_HOST ?? "https://us.i.posthog.com";
export const posthogUiHost =
  process.env.NEXT_PUBLIC_POSTHOG_UI_HOST ?? "https://us.posthog.com";

export function buildPosthogCspReportEndpoint(
  projectToken: string | undefined,
): string | null {
  if (!projectToken) {
    return null;
  }

  return `${posthogManagedProxyHost}/report/?token=${projectToken}`;
}
